"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useRouter;

var _reactRouter = require("react-router");

function useRouter(matchProps) {
  var history = (0, _reactRouter.useHistory)();
  var location = (0, _reactRouter.useLocation)();
  var match = matchProps ? (0, _reactRouter.matchPath)(location.pathname, matchProps) : null;
  return {
    history: history,
    location: location,
    match: match
  };
}